import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'esc-privacy-notice-dialog',
  templateUrl: './privacy-notice-dialog.component.html',
  styleUrls: ['./privacy-notice-dialog.component.scss']
})
export class PrivacyNoticeDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
